/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { RouterModule, Routes } from '@angular/router';

import { AlertComponent } from './alert.component';
import { AlertDataComponent } from './data/alert-data.component';
import { AlertResolver } from './shared/alert.resolver';
import { CanDeactivateViaEditGuardService } from './../core/services/can-deactivate-via-edit-guard.service';
import { NgModule } from '@angular/core';

const alertRoutes: Routes = [
    {
        path: 'alerts',
        component: AlertComponent,
        data: { tab: 'Alerts' },
        resolve: {
            tabData: AlertResolver
        },
        canDeactivate: [CanDeactivateViaEditGuardService],
        children: [
            {
                path: 'data',
                component: AlertDataComponent,
                data: { tab: 'Alerts' },
                resolve: {
                    tabData: AlertResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'data/:tabid',
                component: AlertDataComponent,
                data: { tab: 'Alerts' },
                resolve: {
                    tabData: AlertResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            }]
    }
];

/**
 * @export
 * @class LocoRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forChild(alertRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class AlertRoutingModule {

}
